import React, { type PropsWithChildren } from 'react'

import { useFeatureFlagValue } from '../../hooks/useFeatureFlagValue'
import { type FeatureFlags } from '../../types/FeatureFlags'

export type FeatureFlagEnabledProps = PropsWithChildren & {
  flag: keyof FeatureFlags
}

export function FeatureFlagEnabled({
  children,
  flag,
}: FeatureFlagEnabledProps) {
  const value = useFeatureFlagValue(flag)

  if (value) {
    return children
  }

  return <></>
}
